import { render, staticRenderFns } from "./ClassroomExercisesReading.vue?vue&type=template&id=719949c3&"
import script from "./ClassroomExercisesReading.vue?vue&type=script&lang=ts&"
export * from "./ClassroomExercisesReading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports